/* prefix for id of all ad slot elements */
export const adSlotIdPrefix = 'dfp-ad--';
